import { render, staticRenderFns } from "./ku-article-timeline.vue?vue&type=template&id=5f7dfa3e"
import script from "./ku-article-timeline.vue?vue&type=script&lang=js"
export * from "./ku-article-timeline.vue?vue&type=script&lang=js"
import style0 from "./ku-article-timeline.vue?vue&type=style&index=0&id=5f7dfa3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports